module.exports = __webpack_public_path__ + "static/media/spirit_boots.59c01ee5.png";